import React, { useEffect, useRef, useState } from "react";
import { Client, Account } from "appwrite";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../other/AuthContext";
import { Link } from "react-router-dom";


const Login = () => {

    const navigate = useNavigate();
    const { user, loginUser, registerUser } = useAuth();

    //refs holds reference to dom objects in this case the forms.
    const loginForm = useRef(null);
    const RegisterForm = useRef(null);

    //title text
    const [title, setTitle] = useState("Login");

    //error text
    const [error, setError] = useState("");

    //conditional rendering
    const [pagestate, setpagestate] = useState("Login");

    useEffect(() => {

        if (user) {
            navigate('/Home');
        }


    }, []);


    async function handleLogin(e) {

        e.preventDefault();

        const email = loginForm.current.email.value;
        const password = loginForm.current.password.value;
        const userInfo = { email, password };

        loginUser(userInfo);

    }

    async function handleRegister(e) {
        e.preventDefault();

        const email = RegisterForm.current.email_reg.value;
        const password = RegisterForm.current.password_reg.value;
        const name = RegisterForm.current.firstname_reg.value;

        const userInfo = { email, password, name };

        registerUser(userInfo);

    }

    async function togglePageState() {
        setpagestate(pagestate === "Login" ? "Register" : "Login");
    }




    return (


        <div className="auth_box_container" >

            <div className="auth_box_center">
                {pagestate === "Login" ? (

                    //Login component
                    <div>

                        <form className="authform" onSubmit={handleLogin} ref={loginForm}>
                            <h2>Login</h2>

                            <div className="form-element">

                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    placeholder="Enter your email"
                                    required
                                />
                            </div>

                            <div className="form-element">
                                <label htmlFor="password">Password</label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    placeholder="Enter your password"
                                    required
                                />
                            </div>

                            <button type="submit" className="submit-button">
                                Login
                            </button>



                        </form>

                        <div className="flex-box-h">
                            <p>Dont have an account?</p>

                            <button className="tertiary-button" type="button" onClick={togglePageState}>
                                {pagestate === "Login" ? "Register" : "Login"}
                            </button>


                        </div>

                    </div>

                ) : (

                    //Register component
                    <div>


                        <form className="authform" onSubmit={handleRegister} ref={RegisterForm}>
                            <h2>Register</h2>


                            <div className="form-element">

                                <label htmlFor="email">First Name</label>
                                <input
                                    type="text"
                                    id="firstname_reg"
                                    name="firstname_reg"
                                    placeholder="Enter First Name"
                                    required
                                />
                            </div>

                            <div className="form-element">

                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email_reg"
                                    name="email_reg"
                                    placeholder="Enter your email"
                                    required
                                />
                            </div>

                            <div className="form-element">

                                <label htmlFor="password">Password</label>
                                <input
                                    type="password"
                                    id="password_reg"
                                    name="password_reg"
                                    placeholder="Enter your password"
                                    required
                                />
                            </div>

                            <button  type="submit" className="submit-button">
                                Create Account
                            </button>



                        </form>



                        <div className="flex-box-h">
                            <p>Already have an account?</p>

                            <button className="tertiary-button" type="button" onClick={togglePageState}>
                                {pagestate === "Login" ? "Register" : "Login"}
                            </button>


                        </div>


                    </div>

                )}
            </div>












        </div>
    );
};

export default Login;
